import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Grid,
  Typography,
  Box,
  IconButton,
  InputAdornment,
  MenuItem,
  CircularProgress,
  Chip,
  FormHelperText,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Close, Add, Remove } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import axios from 'axios';
import moment from 'moment';
import {
  useSelector
} from 'react-redux'

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    maxWidth: '800px',
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  stepContent: {
    minHeight: '400px',
    paddingTop: theme.spacing(3),
  },
  chemicalRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addButton: {
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  }
}));

const steps = ['Job Selection', 'Timing & Weather', 'Chemical Application', 'Compliance'];

const windDirections = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

function CreateSprayLogModal({ open, onClose, url, jobsites, chemicals, sprayTechs, AllWorkorders }) {
  console.log('CreateSprayLogModal opened:', jobsites)
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const clients = useSelector(state => state.clients)
  // console.log('got clients', clients)
  // Form data state
  const [formData, setFormData] = useState({
    // Step 1
    jobSite: null,
    client: null,
    workorder: null,
    date: new Date(),
    sprayTech: null,
    
    // Step 2
    startTime: null,
    stopTime: null,
    temp: '',
    windSpeed: '',
    windDir: '',
    comments: '',
    
    // Step 3
    chemicalDetails: [{ chemical: null, mixRate: '', amount: '' }],
    waterStart: '',
    waterEnd: '',
    
    // Step 4 - compliance info
    licenseNum: '',
    licenseExp: null
  });

  // Lookup data
  const [workorders, setWorkorders] = useState([]);
  const [errors, setErrors] = useState({});

  // PMD info will be handled by backend

  // Fetch workorders when jobsite changes
  useEffect(() => {
    if (formData.jobSite) {
      fetchWorkorders(formData.jobSite._id);
    }
  }, [formData.jobSite]);

  // Auto-populate compliance data when tech is selected
  useEffect(() => {
    if (formData.sprayTech) {
      setFormData(prev => ({
        ...prev,
        licenseNum: formData.sprayTech.licenseNum || '',
        licenseExp: formData.sprayTech.licenseExp || null
      }));
    }
  }, [formData.sprayTech]);

  const fetchWorkorders = async (jobSiteId) => {
    // console.log('fetchWorkorders...', AllWorkorders)
    // console.log(formData)
    // if (jobSiteId) {
    //   // console.log('jobSiteId', jobSiteId)
    //   let wos = AllWorkorders?.filter(wo => (wo?.jobSiteId === jobSiteId))
    //   // console.log('Matching wos...', wos)
    //   setWorkorders(wos)
    // }
    setLoading(true);
    try {
      const response = await axios.get(
        `${url}/api/hmi/genericGetRequest?type=GET_SPRAY_JOBS&jobSiteId=${jobSiteId}`
      );
      console.log('got workorders..', response)
      setWorkorders(response.data?.data || response.data || []);
    } catch (error) {
      console.error('Error fetching workorders:', error);
      setWorkorders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const validateStep = (step) => {
    const newErrors = {};
    
    switch (step) {
      case 0:
        if (!formData.jobSite) newErrors.jobSite = 'Jobsite is required';
        // if (!formData.workorder) newErrors.workorder = 'Work order is required';
        if (!formData.sprayTech) newErrors.sprayTech = 'Technician is required';
        if (!formData.date) newErrors.date = 'Date is required';
        break;
      case 1:
        if (!formData.startTime) newErrors.startTime = 'Start time is required';
        if (!formData.stopTime) newErrors.stopTime = 'Stop time is required';
        if (!formData.temp) newErrors.temp = 'Temperature is required';
        if (!formData.windSpeed) newErrors.windSpeed = 'Wind speed is required';
        if (!formData.windDir) newErrors.windDir = 'Wind direction is required';
        break;
      case 2:
        if (!formData.waterStart) newErrors.waterStart = 'Water start reading is required';
        if (!formData.waterEnd) newErrors.waterEnd = 'Water end reading is required';
        if (formData.chemicalDetails.length === 0 || !formData.chemicalDetails[0].chemical) {
          newErrors.chemicals = 'At least one chemical is required';
        }
        break;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    const wo = formData?.workorder
    if (wo?._id) {
      console.log(wo)
      if (wo?.work_completed_at) {
        console.log('wo...complete_at', wo.work_completed_at)
        setFormData(prev => ({
          ...prev,
          date: wo.work_completed_at
        }));
        return
      }
      if (wo?.completedDate) {
        console.log('use this completedDate', wo.completedDate)
        setFormData(prev => ({
          ...prev,
          date: wo.completedDate
        }));
        return
      }
      if (wo?.scheduledDate) {
        console.log('Scheduled Date this', wo.scheduledDate)
        setFormData(prev => ({
          ...prev,
          date: wo.scheduledDate
        }));
        return
      }
      
    }
  }, [formData?.workorder])
  
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error for this field
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: undefined
      }));
    }
  };

  const handleJobsiteChange = (event, value) => {
    // console.log('Jobsite', value)
    // console.log('clients', clients)
    let client = clients?.find(c => (c?._id?.toString() === value?.client?.toString() ))
    // console.log('client', client)
    if (client)
    setFormData(prev => ({
      ...prev,
      jobSite: value,
      client: client ? client : value?.client || null,
      workorder: null // Reset workorder when jobsite changes
    }));
  };

  const addChemical = () => {
    setFormData(prev => ({
      ...prev,
      chemicalDetails: [...prev.chemicalDetails, { chemical: null, mixRate: '', amount: '' }]
    }));
  };

  const removeChemical = (index) => {
    setFormData(prev => ({
      ...prev,
      chemicalDetails: prev.chemicalDetails.filter((_, i) => i !== index)
    }));
  };

  const updateChemical = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      chemicalDetails: prev.chemicalDetails.map((chem, i) => 
        i === index ? { ...chem, [field]: value } : chem
      )
    }));
  };

  const calculateWaterUsed = () => {
    // console.log('calculateWaterUsed...', formData)
    // console.log('start: %s   End: %s  ', formData?.waterStart, formData?.waterEnd)
    const start = parseFloat(formData.waterStart) || 0;
    const end = parseFloat(formData.waterEnd) || 0;
    // console.log(start, end)
    let waterUsed = Math.max(0, start - end);
    // console.log('Water used', waterUsed)
    return waterUsed
  };

  const handleSubmit = async () => {
    if (!validateStep(activeStep)) return;
    
    setSubmitting(true);
    console.log('formData', formData)
    try {
      const sprayLogData = {
        date: formData.date,
        jobSite: formData.jobSite._id,
        client: formData.client._id,
        workorder: formData?.workorder?._id || null,
        sprayTech: formData.sprayTech._id,
        techName: formData.sprayTech.name,
        address: formData.jobSite.address,
        bizName: formData.jobSite.bizName || formData.client.bizName,
        
        startTime: moment(formData.startTime).format('HH:mm'),
        stopTime: moment(formData.stopTime).format('HH:mm'),
        temp: formData.temp,
        windSpeed: formData.windSpeed,
        windDir: formData.windDir,
        comments: formData.comments,
        
        chemicalDetails: formData.chemicalDetails.filter(c => c.chemical).map(c => ({
          name: c.chemical.name,
          epaNum: c.chemical.epaNum,
          mixRate: c.mixRate,
          amount: c.amount,
          _id: c.chemical._id,
          herbicideDetails: c.chemical?.herbicideDetails || null
        })),
        
        waterStart: parseFloat(formData.waterStart),
        waterEnd: parseFloat(formData.waterEnd),
        waterUsed: calculateWaterUsed(),
        
        licenseNum: formData.licenseNum,
        licenseExp: formData.licenseExp,
        
        isComplete: true,
        status: 'completed',
        percentComplete: 100,
        created_at: new Date()
      };

      const resp = await axios.post(
        `${url}/api/hmi/genericPostRequest?type=CREATE_SPRAY_LOG`,
        { data: sprayLogData }
      );
        console.log('Response...', resp)
      // Success - close modal and refresh
      onClose(true);
      resetForm();
    } catch (error) {
      console.error('Error creating spray log:', error);
      alert('Error creating spray log. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      jobSite: null,
      client: null,
      workorder: null,
      date: new Date(),
      sprayTech: null,
      startTime: null,
      stopTime: null,
      temp: '',
      windSpeed: '',
      windDir: '',
      comments: '',
      chemicalDetails: [{ chemical: null, mixRate: '', amount: '' }],
      waterStart: '',
      waterEnd: '',
      pmdNum: '',
      qualifyingParty: '',
      qpNum: '',
      licenseNum: '',
      licenseExp: null
    });
    setActiveStep(0);
    setErrors({});
  };

  const renderStepContent = (step) => {
    // console.log('328...', workorders)
    switch (step) {
      case 0:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Autocomplete
                options={jobsites || []}
                getOptionLabel={(option) => `${option?.communityName ? `${option.communityName} - ` : '' }${option?.name ? option.name : option.clientName} - ${option.address} ${option?.buildingNumber ? `Bldg #${option.buildingNumber} ` : ''}${option.city}`}
                value={formData.jobSite}
                onChange={handleJobsiteChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Jobsite"
                    variant="outlined"
                    required
                    error={!!errors.jobSite}
                    helperText={errors.jobSite}
                  />
                )}
              />
            </Grid>
            
            {formData.client && (
              <Grid item xs={12}>
                <TextField
                  label="Client"
                  value={formData.client.displayName || formData.client.searchName}
                  variant="outlined"
                  fullWidth
                  disabled
                />
              </Grid>
            )}
            
            <Grid item xs={12}>
              <Autocomplete
                options={workorders || []}
                getOptionLabel={(option) => {
                  // console.log('Option', option)
                  return `WO #${option.number} - ${new Date(option.scheduledDate).toLocaleDateString()} (${option?.jobSiteAddress} - ${option.status} ${option?.workComplete ? `Work Complete ${new Date(option?.work_completed_at)?.toLocaleDateString()}` : ''})`
                }}
                value={formData.workorder}
                onChange={(e, value) => handleInputChange('workorder', value)}
                disabled={!formData.jobSite}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Work Order"
                    variant="outlined"
                    required
                    error={!!errors.workorder}
                    helperText={errors.workorder || (!formData.jobSite && 'Select a jobsite first')}
                  />
                )}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <KeyboardDatePicker
                label="Service Date"
                format="MM/dd/yyyy"
                value={formData.date}
                onChange={(date) => handleInputChange('date', date)}
                variant="inline"
                inputVariant="outlined"
                fullWidth
                required
                error={!!errors.date}
                helperText={errors.date}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={sprayTechs || []}
                getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
                value={formData.sprayTech}
                onChange={(e, value) => handleInputChange('sprayTech', value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Spray Technician"
                    variant="outlined"
                    required
                    error={!!errors.sprayTech}
                    helperText={errors.sprayTech}
                  />
                )}
              />
            </Grid>
          </Grid>
        );
        
      case 1:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box mb={2} p={2} bgcolor="background.paper" borderRadius={1}>
                <Typography variant="body1">
                  <strong>Service Date:</strong> {moment(formData.date).format('MMMM DD, YYYY')}
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <KeyboardTimePicker
                label="Start Time"
                value={formData.startTime}
                onChange={(time) => handleInputChange('startTime', time)}
                variant="inline"
                inputVariant="outlined"
                fullWidth
                required
                error={!!errors.startTime}
                helperText={errors.startTime}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <KeyboardTimePicker
                label="Stop Time"
                value={formData.stopTime}
                onChange={(time) => handleInputChange('stopTime', time)}
                variant="inline"
                inputVariant="outlined"
                fullWidth
                required
                error={!!errors.stopTime}
                helperText={errors.stopTime}
              />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                label="Temperature"
                value={formData.temp}
                onChange={(e) => handleInputChange('temp', e.target.value)}
                variant="outlined"
                fullWidth
                required
                type="number"
                InputProps={{
                  endAdornment: <InputAdornment position="end">°F</InputAdornment>,
                }}
                error={!!errors.temp}
                helperText={errors.temp}
              />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                label="Wind Speed"
                value={formData.windSpeed}
                onChange={(e) => handleInputChange('windSpeed', e.target.value)}
                variant="outlined"
                fullWidth
                required
                type="number"
                InputProps={{
                  endAdornment: <InputAdornment position="end">mph</InputAdornment>,
                }}
                error={!!errors.windSpeed}
                helperText={errors.windSpeed}
              />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Wind Direction"
                value={formData.windDir}
                onChange={(e) => handleInputChange('windDir', e.target.value)}
                variant="outlined"
                fullWidth
                required
                error={!!errors.windDir}
                helperText={errors.windDir}
              >
                {windDirections.map((dir) => (
                  <MenuItem key={dir} value={dir}>
                    {dir}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                label="Comments"
                value={formData.comments}
                onChange={(e) => handleInputChange('comments', e.target.value)}
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                placeholder="Any additional notes about the service..."
              />
            </Grid>
          </Grid>
        );
        
      case 2:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Chemical Application
              </Typography>
              {errors.chemicals && (
                <FormHelperText error>{errors.chemicals}</FormHelperText>
              )}
            </Grid>
            
            {formData.chemicalDetails.map((chemical, index) => (
              <Grid item xs={12} key={index}>
                <Box className={classes.chemicalRow}>
                  <Autocomplete
                    style={{ flex: 2 }}
                    options={chemicals || []}
                    getOptionLabel={(option) => `${option.name} (EPA: ${option.epaNum})`}
                    value={chemical.chemical}
                    onChange={(e, value) => updateChemical(index, 'chemical', value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Chemical"
                        variant="outlined"
                        required={index === 0}
                      />
                    )}
                  />
                  
                  {/* <TextField
                    style={{ flex: 1 }}
                    label="Mix Rate"
                    value={chemical.mixRate}
                    onChange={(e) => updateChemical(index, 'mixRate', e.target.value)}
                    variant="outlined"
                    placeholder="oz/gal"
                  />
                   */}
                  <TextField
                    style={{ flex: 1 }}
                    label="Amount Used (OUNCES)"
                    value={chemical.amount}
                    onChange={(e) => updateChemical(index, 'amount', e.target.value)}
                    variant="outlined"
                    placeholder="oz"
                  />
                  
                  {formData.chemicalDetails.length > 1 && (
                    <IconButton
                      color="secondary"
                      onClick={() => removeChemical(index)}
                    >
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              </Grid>
            ))}
            
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<Add />}
                onClick={addChemical}
                className={classes.addButton}
              >
                Add Chemical
              </Button>
            </Grid>
            
            <Grid item xs={12}>
              <Divider />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                label="Water Start"
                value={formData.waterStart}
                onChange={(e) => handleInputChange('waterStart', e.target.value)}
                variant="outlined"
                fullWidth
                required
                type="number"
                error={!!errors.waterStart}
                helperText={errors.waterStart}
              />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                label="Water End"
                value={formData.waterEnd}
                onChange={(e) => handleInputChange('waterEnd', e.target.value)}
                variant="outlined"
                fullWidth
                required
                type="number"
                error={!!errors.waterEnd}
                helperText={errors.waterEnd}
              />
            </Grid>
            
            <Grid item xs={12} md={4}>
              <TextField
                label="Water Used"
                value={calculateWaterUsed()}
                variant="outlined"
                fullWidth
                disabled
                InputProps={{
                  endAdornment: <InputAdornment position="end">gal</InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
        );
        
      case 3:
        return (
          <Grid container spacing={3}>
            {/* <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Compliance Information
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                PMD information will be added by the backend. License info is from the technician.
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                label="License Number"
                value={formData.licenseNum}
                variant="outlined"
                fullWidth
                disabled
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                label="License Expiration"
                value={formData.licenseExp ? moment(formData.licenseExp).format('MM/DD/YYYY') : ''}
                variant="outlined"
                fullWidth
                disabled
              />
            </Grid> */}
            
            <Grid item xs={12}>
              <Box mt={2} p={2} bgcolor="background.paper" borderRadius={1}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Summary</strong>
                </Typography>
                <Typography variant="body2">
                  Jobsite: {formData.jobSite?.bizName} - {formData.jobSite?.address}
                </Typography>
                <Typography variant="body2">
                  Date: {moment(formData.date).format('MM/DD/YYYY')}
                </Typography>
                <Typography variant="body2">
                  Technician: {formData.sprayTech?.name}
                </Typography>
                <Typography variant="body2">
                  Time: {formData.startTime ? moment(formData.startTime).format('h:mm A') : ''} - {formData.stopTime ? moment(formData.stopTime).format('h:mm A') : ''}
                </Typography>
                <Typography variant="body2">
                  Chemicals: {formData.chemicalDetails.filter(c => c.chemical).map(c => c.chemical.name).join(', ')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        );
        
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      classes={{ paper: classes.dialogPaper }}
      maxWidth={false}
    >
      <DialogTitle>
        Manual Spray Log Entry
        <IconButton
          className={classes.closeButton}
          onClick={() => onClose(false)}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Stepper activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        <Box className={classes.stepContent}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
              <CircularProgress />
            </Box>
          ) : (
            renderStepContent(activeStep)
          )}
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
        >
          Back
        </Button>
        <Box flexGrow={1} />
        <Button onClick={() => onClose(false)}>
          Cancel
        </Button>
        {activeStep === steps.length - 1 ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? <CircularProgress size={24} /> : 'Submit'}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
          >
            Next
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default CreateSprayLogModal;